import { useEffect, useMemo, useState } from 'react';
import { getEffectiveRefreshStatus } from './reportRefreshStatus';

// This hook reconciles optimistic refresh UI state with server-reported refresh
// status so the report view can feel responsive without getting stuck on stale optimism.
const useReportRefreshRuntimeState = ({ reportId, refreshStatusData }) => {
  const [lastRefreshCompletedAt, setLastRefreshCompletedAt] = useState(null);
  const [optimisticRefreshStatus, setOptimisticRefreshStatus] = useState(null);

  const effectiveRefreshStatus = useMemo(
    () => getEffectiveRefreshStatus({ refreshStatus: refreshStatusData, optimisticRefreshStatus }),
    [optimisticRefreshStatus, refreshStatusData]
  );

  useEffect(() => {
    if (refreshStatusData?.completedAt) {
      setLastRefreshCompletedAt(refreshStatusData.completedAt);
    }
    // Once the server reports the same refreshId we optimistically created, the
    // authoritative server state can take over and clear the optimistic placeholder.
    if (
      optimisticRefreshStatus?.refreshId &&
      refreshStatusData?.refreshId &&
      refreshStatusData.refreshId === optimisticRefreshStatus.refreshId
    ) {
      setOptimisticRefreshStatus(null);
    }
  }, [optimisticRefreshStatus?.refreshId, refreshStatusData]);

  useEffect(() => {
    setLastRefreshCompletedAt(null);
    setOptimisticRefreshStatus(null);
  }, [reportId]);

  return {
    effectiveRefreshStatus,
    lastRefreshCompletedAt,
    setOptimisticRefreshStatus,
  };
};

export default useReportRefreshRuntimeState;
